import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { AccessHistory } from '../models';
import { AccessHistoryActions, AccessHistoryActionTypes } from '../actions';

export interface AccessHistoryState extends EntityState<AccessHistory> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<AccessHistory> = createEntityAdapter<AccessHistory>({
  selectId: (accessHistory) => accessHistory.id,
});

export const initialAccessHistoryState: AccessHistoryState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function accessHistoryReducer(
  state = initialAccessHistoryState,
  action: AccessHistoryActions,
): AccessHistoryState {
  switch (action.type) {
    case AccessHistoryActionTypes.ToggleAccessHistoryPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case AccessHistoryActionTypes.LoadAccessHistoryPage:
      return adapter.addMany(action.payload.accessHistories, {
        ...initialAccessHistoryState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case AccessHistoryActionTypes.CancelAccessHistoryPage:
      return { ...state, query: new QueryParamsModel({}) };

    case AccessHistoryActionTypes.ThrowAccessHistoryError:
      return {
        ...state,
        pageLoading: false,
        error: action.payload.error,
      };

    case AccessHistoryActionTypes.ClearAccessHistoryError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
